<template>
  <el-main class="userdetail">
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>其他管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/stationery' }">办公用品管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pathtype }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 休假信息 -->
    <div class="form myform">
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" label-position="left">
        <div class="formtitle">办公用品信息</div>
        <el-form-item label="物品类型：" prop="category_id">
          <el-col :span="12">
            <el-cascader v-model="form.category_id" :options="officeTypeList" :props="{ expandTrigger: 'hover' }"
              @change="handleofficeChange" style="width: 100%;"></el-cascader>
          </el-col>
        </el-form-item>
        <el-form-item label="物品名称：" prop="name">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.name" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="序列码：" prop="office_code">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.office_code" clearable />
          </el-col>
        </el-form-item>
        <el-form-item label="规格型号：" prop="office_detail">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.office_detail">
            </el-input>
          </el-col>
        </el-form-item>
        <template>
          <el-form-item label="示例图片" prop="example_img">
            <input hidden v-model="form.example_img" />
            <el-upload action="#" list-type="picture-card" :file-list="fileList" :auto-upload="false"
              :before-upload="(a) => beforeUpload(a, 'fileList')"
              :on-change="(a, b) => imgchange(a, b, '7', 'example_img', 'fileList')">
              <i slot="default" class="el-icon-picture-outline dimg">
                <p>点击上传图</p>
                <!-- <span>建议尺寸{{ w }}*{{ h }}</span> -->
              </i>
              <div slot="file" slot-scope="{ file }">
                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                <span class="el-upload-list__item-actions">
                  <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span v-if="!disabled" class="el-upload-list__item-delete"
                    @click="handleRemove(file, fileList, 'fileList', 'example_img')">
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </template>
        <el-form-item label="购买单价：" prop="price">
          <el-col :span="12">
            <el-input placeholder="请输入" maxlength="100" v-model="form.price" clearable />
          </el-col>
        </el-form-item>
        <!-- 休假证明 -->
        <template>
          <ul class="anlist">
            <li v-for="(item, index) in voucher_file_list" :key="index">
              <div class="abox">
                <el-form-item :label='`上传购买凭证${index + 1}：`'>
                  <!-- 选择文件 -->
                  <el-col :span="3" v-if="form.status != '5'">
                    <el-upload class="upload-demo" ref="upFile" action="#" :limit="1" :show-file-list="false"
                      :auto-upload="false" accept=".pdf, .doc, .docx, .xls, .xlsx, .jpg, .png" :file-list="item.flist"
                      :on-change="(arg) => uploadFile(arg, 'voucher_file_list', 'upFile', item, index)">
                      <el-button size="small" style="width: 80px;">选择文件</el-button>
                    </el-upload>
                  </el-col>
                  <!-- 文件预览及下载 -->
                  <template v-if="item.origin_name">
                    <el-col :span="10">
                      <el-col :span="18">
                        <div class="origin-name">{{
                          item.origin_name }}</div>
                      </el-col>
                      <el-col :span="4">
                        <el-link type="primary" style="margin-right:5px" :href="item.httpFile"
                          target="_blank">查看</el-link>
                      </el-col>
                    </el-col>
                  </template>
                </el-form-item>
              </div>
              <el-button class="bbtn" icon="el-icon-minus" @click="removeJob(voucher_file_list, index)"
                circle></el-button>

            </li>
            <el-button type="primary" style="margin: 0 0 15px 150px" class="addbtn"
              @click="addJob(voucher_file_list)">上传购买凭证</el-button>
          </ul>
        </template>
        <el-form-item label="当前状态：" prop="status">
          <el-col>
            <el-radio-group v-model="form.status">
              <el-radio label="0">备用</el-radio>
              <el-radio label="1">在用</el-radio>
              <el-radio label="2">已报废</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="备注：" prop="desc">
          <el-col :span="12">
            <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
              v-model="form.desc">
            </el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div class="btnarea">
        <el-col :span="10">
          <el-button @click="resetForm('form')">取消</el-button>
          <el-button type="primary" @click="submitForm('form')">保存</el-button>
        </el-col>
      </div>
    </div>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
// import { thousands } from '@/utils/index.js'
import store from '@/store'
import _ from 'lodash'

export default {
  name: 'vacaAdd',
  data() {
    return {
      returnUrl: true, // 确实是否为手动按钮触发，还是右上角触发
      nodeLimtList: [],
      level: '',
      userId: '',
      uid: '',
      itemList: [],
      officeTypeList: [],
      userArr: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000; // 86400000 毫秒 = 1 天  
        }
      },
      form: {
        office_id: '', //员编辑时必传id
        category_id: '', //类型
        office_code: '', //序列码
        office_detail: '', //设备详情
        name: '',
        price: '',
        desc: '', //备注
        status: '', //当前状态
        project_id: '', //关联项目id

      },
      rules: {
        // client_company: [
        //   {
        //     required: true,
        //     message: '请输入客户公司名称',
        //     trigger: 'change',
        //   },
        // ],
        // brand: [
        //   {
        //     required: true,
        //     message: '请输入品牌',
        //     trigger: 'change',
        //   },
        // ],
      },
      voucher_file_list: [
        { origin_name: '', file_name: '', httpFile: '', file_id: '', flist: [] },
      ],
      holidayDetail: {},
      holidayDetailList: {},
      typeList: [],
      del_job_list: [],
      canAgentList: [],
      agentList: [
        { id: '', agent_id: '', work_reason: '' },
      ],
      del_agent_list: [],
      confirmShow: false,
      restList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      disabled: false,
      fileList: [],
    }
  },
  computed: {

  },
  created() {
    this.query = this.$route.query
  },
  mounted() {
    this.getOfficeType()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;
      // 移除'#'字符  
      const url = hash.substring(1);

      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },

    link(url) {
      this.$router.push(url)
    },

    getUserDetail(uid) {
      this.$fly
        .post('ApiStaffReimbursement_getStaffInfo.html', {
          uid: uid,
        })
        .then((res) => {
          this.userArr = res
        })
    },

    getOfficeType() {
      this.$fly
        .post('apiOffice_getOfficeTypeDownList.html', {

        })
        .then((res) => {
          this.officeTypeList = res.length ? res : []
        })
    },

    getDetail(id) {
      api.getStaffHolidayDetail({
        holiday_detail_id: id,
      }).then(() => {
        this.getStoreFn()
      })
    },

    getStoreFn() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      setTimeout(() => {
        //权限
        this.level = store.state.level
        this.userId = store.state.userId

      }, 200);
    },

    //选择文件
    uploadFile(file, fileList, ref, item, index) {
      let formData = new FormData();
      formData.append("file_arr", file.raw);
      formData.append("type", 6);
      api.uploadFile(formData)
        .then((res) => {
          this[fileList][index] = {
            ...item,
            origin_name: res.origin_name,
            file_name: res.file_name,
            httpFile: res.httpFile,
          }
          this.$forceUpdate()
          this.$refs[ref][index].clearFiles();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addJob(arr) {
      arr.push({
        origin_name: '', file_name: '', httpFile: '', file_id: '', flist: []
      });
    },

    removeJob(arr, index) {
      if (arr[index].file_id) {
        this.del_job_list.push(arr[index].file_id);
      }
      console.log(this.del_job_list);
      arr = arr.splice(index, 1);
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUpdateVacation()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    addUpdateVacation() {
      this.form.holiday_detail_id = this.query.id || ''
      this.form.option = this.form.holiday_detail_id ? '2' : '1'
      const tempForm = JSON.parse(JSON.stringify(this.form))
      const url = ''
      this.$fly
        .post(url, {
          ...tempForm,
          job_file: JSON.stringify(this.voucher_file_list),
          agent_str: JSON.stringify(this.agentList),
          file_del_str: this.del_job_list.toString(),
          agent_del_str: this.del_agent_list.toString(),
        })
        .then(() => {
          this.$router.go(-1)
        })
    },

    resetForm(formName) {
      this.returnUrl = false
      this.$refs[formName].resetFields()
      this.$router.go(-1)
    },

    handleofficeChange() {

    },

    handleRemove(file, fileList, key = 'fileList') {
      this.form.img_name = ''
      this[key] = _.without(fileList, file)
    },

    beforeUpload(file, key) {
      this[key] = []
      console.log(file)
      return true
    },

    async imgchange(file, filelist, type, key, listKey = 'fileList') {
      this[listKey] = []
      console.log(file, filelist)
      this[listKey] = [file]
      const img = await this.checkImg(file)
      this.uploadImage(img, type, key)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    uploadImage(img, type = 3, key = 'img_name') {
      api.uploadImage({
        img,
        type,
      })
        .then((res) => {
          this.form[key] = res['img_name']
          console.log('%c [ this.form[key] ]-45', 'font-size:13px; background:pink; color:#bf2c9f;', res)

        })
    },

    checkImg(file) {
      return new Promise((resolve) => {
        const img = new Image()
        img.src = file.url
        img.onload = function () {
          let dataURL = ''
          let canvas = document.createElement('canvas')
          let width = img.width // 确保canvas的尺寸和图片一样
          let height = img.height
          canvas.width = width
          canvas.height = height
          canvas.getContext('2d').drawImage(img, 0, 0, width, height)
          dataURL = canvas.toDataURL('image/png')
          // this.uploadImage(dataURL)
          resolve(dataURL)

          if (this.w && (width !== this.w || height !== this.h))
            this.$message.error(
              '图片宽高与要求不一致。' + 'width:' + img.width + ',height:' + img.height
            )
        }.bind(this)
      })
    }

  },
}
</script>

<style lang="scss" scoped>
.userdetail {
  .holiday-head {
    @extend %box;
    @extend %start;
    align-items: center;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    .holi-body {
      &.left {
        width: 70%;

        .hold-head-title {
          font: 600 28px/1 $font;
        }

        .hold-head-content {
          padding: 10px 0;

          div {
            font: 400 16px/1.5 $font;
          }
        }
      }

      &.right {
        width: 30%;

        .holiday-box {
          @extend %center;
          width: 180px;
          height: 80px;
          padding: 10px;
          color: #fff;
          border-radius: 10px;

          &.holi1 {
            background: #02a7f0;
          }

          &.holi2 {
            background: #ec808d;
          }

          &.holi3 {
            background: #81d3f8;
          }

          &.holi4 {
            background: #81d3f8;
          }

          &.holi5 {
            background: #70b603;
          }

          &.holi6 {
            background: #f59a23;
          }

          &.holi7 {
            background: #8400ff;
          }

          &.holi8 {
            background: #333333;
          }

          .box-title {
            font: 600 24px/1 $font;
            margin-bottom: 10px;
          }

          .box-info {
            font: 400 20px/1 $font;
          }
        }
      }
    }
  }

  .history {
    @extend %box;
    padding: 30px 40px;
  }

  .base1 {
    @extend %box;
    margin-bottom: 20px;
    padding: 30px 40px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #f2f2f2;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 50%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          padding: 5px 0;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }
      }
    }
  }

  .btnarea {
    @extend %start;
    padding: 30px 0;
    position: relative;

    .left {
      width: 500px;
    }

    .right {
      width: 300px;
    }
  }

  .table {
    @extend %box;
    padding: 20px 40px;
    margin-bottom: 20px;
    position: relative;

    ul {
      @extend %start;
      color: #231f20;
      background: #fff;
      padding: 0 25px;
      border-radius: 20px;
      margin-bottom: 20px;
      position: relative;

      &:last-of-type {
        margin-bottom: 0;
      }

      li {
        width: 40%;
        font: 14px/3 $font;

        p {
          min-height: 42px;
          @extend %start;

          label {
            width: 150px;
            white-space: nowrap;
            flex: none;
          }
        }

        &:last-child {
          width: 60%;
          box-sizing: border-box;
          padding-left: 85px;
        }
      }
    }

    .for-title {
      font: 700 24px/1.5 $font;
      color: #444041;
    }

    .for {
      padding: 25px 0;

      &.grey {
        padding: 25px 20px;
        border-radius: 20px;
        background: #f2f2f2;
        margin-bottom: 20px;
      }

      ul {
        @extend %start;
        color: #231f20;
        background: #f2f2f2;
        padding: 0 25px;
        border-radius: 20px;
        margin-bottom: 20px;
        position: relative;

        &:last-of-type {
          margin-bottom: 0;
        }

        li {
          width: 40%;
          font: 14px/3 $font;

          p {
            height: 42px;
            @extend %start;

            label {
              width: 150px;
              white-space: nowrap;
              flex: none;
            }

            span {
              white-space: nowrap;
            }
          }

          &:last-child {
            width: 60%;
            box-sizing: border-box;
            padding-left: 85px;
          }
        }
      }

      .el-button {
        float: right;
        margin-bottom: 10px;
        position: relative;
      }
    }
  }

  .form.myform {
    padding-left: 100px;
  }

  .form {
    @extend %box;
    padding: 30px;
    margin-bottom: 20px;

    .anlist {
      padding: 0;
      flex-flow: column nowrap;

      li {
        position: relative;
        padding: 0;

        .abtn {
          position: absolute;
          top: 0;
          left: 65%;
        }

        .bbtn {
          position: absolute;
          top: 0;
          left: 60%;
        }
      }
    }
  }

  .formtitle {
    position: relative;
    left: -50px;
    margin-bottom: 30px;
    font-size: 28px;
    line-height: 48px;
    font-weight: 600;
  }
}

.holi-body {
  text-align: left;

  .hold-head-title {
    padding: 10px 0;
    font: 600 20px/1 $font;
  }

  .hold-head-content {
    padding: 10px 0;

    div {
      font: 400 16px/1.5 $font;
    }
  }

}
</style>
